import { createSlice } from '@reduxjs/toolkit';
import { AppThunk } from '../../../app/store';
import { getPiaInfoEndPoint } from '../../../common/api.endPoints';
import { HttpService } from '../../../common/http.service';

export const piaInfoSlice = createSlice({
  name: 'piaInfo',

  initialState: {
    piaInfo: {},
    createPiaInfoFailed: false,
    createPiaInfoError: '',
    createPiaInfoErrorType: '',
    fetchPiaInfoFailed: false,
    fetchPiaInfoError: '',
    fetchPiaInfoErrorType: '',
  },

  reducers: {
    onPiaInfoFetch: (state, action) => {
      state.piaInfo = action.payload;
    },
    onPiaInfoFetchFailed: (state, action) => {
      state.fetchPiaInfoFailed = true;
      state.fetchPiaInfoError = action.payload?.message;
      state.fetchPiaInfoErrorType = action.payload?.type;
    },
    onPiaInfoCreate: (state, action) => {
      state.piaInfo = action.payload;
    },
    onPiaInfoCreateFailed: (state, action) => {
      state.createPiaInfoFailed = true;
      state.createPiaInfoError = action.payload?.message;
      state.createPiaInfoErrorType = action.payload?.type;
    },
  },
});

export const getPiaInfo =
  (applicationId: string): AppThunk =>
  async dispatch => {
    const response = await HttpService.getInstance().get(
      getPiaInfoEndPoint(applicationId),
    );

    if (response && !response.error) {
      const piaInfo = response.parsedBody;
      dispatch(piaInfoActions.onPiaInfoFetch({ piaInfo }));
    } else {
      dispatch(
        piaInfoActions.onPiaInfoFetchFailed(
          response ? response.error : undefined,
        ),
      );
    }
  };

export const postPiaInfo =
  (applicationId: string, info: any, setMessage?: any): AppThunk =>
  async dispatch => {
    const requestBody = { info };
    const response = await HttpService.getInstance().post(
      getPiaInfoEndPoint(applicationId),
      requestBody,
    );

    if (response && !response.error) {
      const piaInfo = response.parsedBody;
      dispatch(piaInfoActions.onPiaInfoCreate({ piaInfo }));
      setMessage({
        children: 'PIA Evidence data saved successfully',
        severity: 'success',
      });
    } else {
      dispatch(
        piaInfoActions.onPiaInfoCreateFailed(
          response ? response.error : undefined,
        ),
      );
      setMessage({
        children: 'Failed in saving PIA Evidence data',
        severity: 'error',
      });
    }
  };

export const piaInfoReducer = piaInfoSlice.reducer;
export const piaInfoActions = piaInfoSlice.actions;
